<template>
	<div class="tooltip-custom" :class="position">
		<transition name="popup" appear>
			<div
				v-if="show"
				class="tooltip-custom-text"
				:style="{ backgroundColor: color, color: color }"
			>
				<div class="flex justify-between items-center">
					<div class="font-uppercase font-bold" style="font-size: 15px; color: black">
						{{ text }}
					</div>
					<div @click="onShow">
						<SVGIcon class="pointer" icon-name="cancel" width="12px" height="12px" stroke="#030303" />
					</div>
				</div>
				<div v-if="description" class="mt-10" style="font-size: 14px; color: black; line-height: 20px;">
					{{ description }}
				</div>
			</div>
		</transition>
		<slot />
	</div>
</template>

<script>
import SVGIcon from '~/components/interface/SVGIcon'

export default {
	name: 'TooltipCustom',
	components: { SVGIcon },
	props: {
		text: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: ''
		},
		color: {
			type: String,
			default: 'white'
		},
		position: {
			type: String,
			default: ''
		},
		toggle: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		show: false
	}),
	watch: {
		toggle: {
			immediate: true,
			handler (val) {
				this.show = val
			}
		}
	},
	methods: {
		onShow () {
			this.show = !this.show

			this.$emit('close')
		}
	}
}
</script>

<style lang="scss">
.tooltip-custom {
	position: relative;
	display: inline-block;
	.tooltip-custom-text {
		position: absolute;
		z-index: 1;
		top: 45px;
		right: -43px;
		min-width: 277px;
		min-height: 50px;
		box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.34);
		border: solid 1.4px #000;
		border-radius: 10px;
		padding: 15px;
		&::after {
			content: "";
			position: absolute;
			bottom: 100%;
			left: 79%;
			border-style: solid;
			border-width: 0 7px 15px 7px;
			border-color: transparent transparent currentColor transparent;
		}
	}
	&.left {
		.tooltip-custom-text {
			left: -18px;
			right: unset;
			&::after {
				left: 6%;
			}
		}
	}
	&.right {
		.tooltip-custom-text {
			right: -10px;
			&::after {
				left: 90%;
			}
		}
	}
	&.top {
		display: block;
		.tooltip-custom-text {
			min-width: 240px;
			right: 35px;
			top: unset;
			bottom: 70px;
			&::after {
				left: 90%;
				top: 100%;
				transform: rotate(180deg);
			}
		}
	}
}
</style>
